import React from 'react'

import { Button } from 'ra-ui-materialui'
import IconFilterList from '@material-ui/icons/FilterList'

import { useFilterList } from '../FilterContext'

export const FilterButton: React.FC = () => {
  const { onOpenFilterModal } = useFilterList()

  return (
    <Button
      size="small"
      color="primary"
      onClick={onOpenFilterModal}
      startIcon={<IconFilterList />}
    >
      <>Filtros</>
    </Button>
  )
}
